
import { useState } from 'react';
import Banner from './Components/Home/Banner';
import Footer from "./Components/Footer";
import Navbar from './Components/NavBar';
import About from './Components/About/About';
import Service from './Components/Services/Services';
import FandQ from './Components/FandQ/FandQ';
import Contact from './Components/Contact/Contact';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css'
import './scrollAnimations.css';
import Under from './Components/Under'
import OurApproach from './Components/OurApproach/OurApproach';
import Technologies from './Components/OurTechnology/Technologies';
import Banner1 from './Components/Banner1';
import Bot from './Components/Bot';
import { useEffect } from 'react';
import BlogPage from './Components/Blog/BlogPage';
import { Helmet } from "react-helmet-async";
export default function Home() {

  const [navhref, setNavhref] = useState("");

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      if (e.keyCode === 123) {
        e.preventDefault();
        e.stopPropagation();
        alert("Access to Developer Tools is disabled.");
      }

      // Block Ctrl+Shift+I
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        e.stopPropagation();
        alert("Access to Developer Tools is disabled.");
      }

      // Block Ctrl+Shift+C
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        e.stopPropagation();
        alert("Access to Developer Tools is disabled.");
      }

      // Block Ctrl+U (View Source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        e.stopPropagation();
        alert("Viewing page source is disabled.");
      }
    };
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  }, [navhref]);

  const handleSelect = (selectedItem) => {
    setNavhref(selectedItem);
  };


  return (
    <><Helmet>
      
        <title>Website Development Services | Cyber Software Developers</title>
        <meta 
          name="description" 
          content="Professional website development services for business and startups." 
        />
      </Helmet>
      <Navbar onSelect={handleSelect} />
      <Bot />
      {
        navhref === "" || navhref === "Home" ? (
          <div>
            <div className="reveal">
              <Banner1 />
            </div>
            <div className="reveal">
              <Service />
            </div>
            <div className="reveal">
              <About />
            </div>
            <div className="reveal">
              <OurApproach />
            </div>
            <div className="reveal">
              <Technologies />
            </div>
            <div className="reveal">
              <FandQ />
            </div>
          </div>
        ) : navhref === "Why Choose Us" ? (
          <div className="reveal">
            <About />
          </div>
        ) : navhref === "Blog" ? (
          <div className="reveal">
            <BlogPage />
          </div>
        ) : navhref === "Contact" ? (
          <div className="reveal">
            <Contact />
          </div>
        ) : navhref === "Courses" ? (
          <div className="reveal">
            <Technologies />
          </div>
        ) : navhref === "project" ? (
          <div className="reveal">
            <Under />
          </div>
        ) : (
          <div className="bg-black h-screen text-white flex items-center justify-center text-4xl">404</div>
        )
      }
      <Footer />
      <div className="space bg-black" ></div>

    </>
  );
}
